import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";


export default function Team() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div>
      <Helmet>
      <title>Meet Our Expert Software Development Team - Technic Mentors</title>
      <link rel="canonical" href="https://technicmentors.com/team/" />
    </Helmet>
      <div
        className="allHeaderBg"
      >
        <div className="allHeader-overlay d-flex align-items-center justify-content-center">
          <div>
            <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
              Our Software Development Team
            </h1>
          </div>
        </div>
      </div>

      <section id="team" className="team section-bg dev-team">
        <div className="container" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out">
          <div className="section-title text-center">
            <h2>Meet Our Expert Team</h2>
            <h3>
              Our Skilled <span>Mentors</span>
            </h3>
            <p>At Technic Mentors, our team is the heart of our success. Comprised of passionate developers, innovative designers, and forward-thinking strategists, we are dedicated to delivering world-class software solutions. Together, we turn visionary ideas into impactful realities, driving excellence at every stage of the development process.</p>
          </div>
    {/* ROW 1 */}
<div className="row">
  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="100">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\nadeem-munir-team-technicmentors.jpg" className="img-fluid executive" alt="ceo of technic mentors" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Nadeem Munir</p><span>Chief Executive Officer</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="200">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\moazzma-team-technicmentors.jpg" className="img-fluid team-member" alt="moazzama-bukhari business success manager" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Moazzama Bukhari</p><span>Business Success Manager</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="300">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\waseem-team-technicmentors.jpg" className="img-fluid executive" alt="waseem munir head of graphics designing" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Waseem Munir</p><span>Head Of Graphics Designing</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="400">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\akhzar-team-technicmentors.jpg" className="img-fluid team-member" alt="akhzar-nazir head of mobile development" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Akhzar Nazir</p><span>Head Of Mobile Development</span></div>
    </div>
  </div>
</div>

{/* ROW 2 */}
<div className="row">
  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="100">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\danish-team-technicmentors.jpg" className="img-fluid team-member" alt="danish-mirza head development department" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Danish Mirza</p><span>Head Development Department</span></div>
    </div>
  </div>
 <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="300">
    <div className="member">
      <div className="member-img">
        <img src="assets/img/Teams/inam.png" className="img-fluid team-member" alt="inam-team" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Inam ul Hassan Cheema</p><span>Director of Cyber Security</span></div>
    </div>
  </div>
   <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="400">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\warisha.jpg" className="img-fluid team-member" alt="laravel-developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Warisha Shuaib</p><span>Project Manager</span></div>
    </div>
  </div>

 

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="100">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\zunnurain-team-technicmentors.jpg" className="img-fluid team-member" alt="zunnurain-masroor e-commerce expert" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Zunnurain Masroor</p><span>E-commerce Expert</span></div>
    </div>
  </div>
</div>

{/* ROW 3 */}
<div className="row">
  {/* <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="100">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\" className="img-fluid team-member" alt=" development department" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Warisha Shuaib</p><span>Project Manager</span></div>
    </div>
  </div> */}
  

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="200">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\luqman-team-technicmentors.jpg" className="img-fluid team-member" alt="luqman-aziz business development executive" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Luqman Aziz</p><span>Business Development Executive</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="300">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\darakhshan-team-technicmentors.jpg" className="img-fluid team-member" alt="darakhshan-naeem laravel developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Darakhshan Naeem</p><span>Laravel Developer</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="400">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\najam-team-technicmentors.jpg" className="img-fluid team-member" alt="najam-us-saqib full stack developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Najam us Saqib</p><span>Full Stack Developer</span></div>
    </div>
  </div>
    <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="300">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\momina-abid-team-technicmentors.jpg" className="img-fluid team-member" alt="momina-abid-team-technicmentors mern stack developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Momina Abid</p><span>MERN Stack Developer</span></div>
    </div>
  </div>
</div>

{/* ROW 4 */}
<div className="row">


  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="200">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\aroosa-team-technicmentors.jpg" className="img-fluid team-member" alt="aroosa-malik wordpress developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Aroosa Malik</p><span>Wordpress Developer</span></div>
    </div>
  </div>
  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="400">
    <div className="member">
      <div className="member-img">
        <img src="assets/img/Teams/farjal.png" className="img-fluid team-member" alt="farjal" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Farjaal Ahmad</p><span>Lead Penetration Tester</span></div>
    </div>
  </div>
 <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="400">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\fatima.png" className="img-fluid team-member" alt="laravel-developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Fatima Babar</p><span>Laravel Developer</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="400">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\ammar-amjad-team-technicmentors.jpg" className="img-fluid team-member" alt="ammar-amjad-team-technicmentors sqa engineer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Ammar Amjad</p><span>SQA Engineer</span></div>
    </div>
  </div>
</div>

{/* ROW 5 */}
<div className="row">
  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="100">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\zubair-team-technicmentors.jpg" className="img-fluid team-member" alt="zubair-team-technicmentors business development executive" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Zubair</p><span>Business Development Executive</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="200">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\tayyaba-tahir-team-technicmentors.jpg" className="img-fluid team-member" alt="tayyaba-tahir-team-technicmentors mobile app developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Tayyaba Tahir</p><span>Mobile App Developer</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="300">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\hamza-amin-team-technicmentors.jpg" className="img-fluid team-member" alt="hamza-amin-team-technicmentors react.js developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Hamza Amin</p><span>React.js Developer</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="400">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\faisal-team-technicmentors.jpg" className="img-fluid team-member" alt="faisal-team-technicmentors react native developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Hafiz Faisal</p><span>React Native Developer</span></div>
    </div>
  </div>
</div>

{/* ROW 6 */}
<div className="row">
  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="100">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\adan.jpg" className="img-fluid team-member" alt="muhammad-adan digital marketing specialist" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Muhammad Adan Raza</p><span>Digital Marketing Specialist</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="200">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\esha-team-technicmentors.jpg" className="img-fluid team-member" alt="esha-aslam sqa engineer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Esha Aslam</p><span>SQA Engineer</span></div>
    </div>
  </div>
  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="200">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\burhann.png" className="img-fluid team-member" alt="muhammad-burhan-shoukat cybersecurity analyst" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Muhammad Burhan Shoukat</p><span>Cybersecurity Analyst</span></div>
    </div>
  </div>
  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="300">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\alisha-team-technicmentors.jpg" className="img-fluid team-member" alt="alisha-saif mern stack developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Alisha Saif</p><span>MERN Stack Developer</span></div>
    </div>
  </div>

 
 
</div>

{/* ROW 7 */}
<div className="row">
  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="100">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\iqra-team-technicmentors.jpg" className="img-fluid team-member" alt="iqra-maqsood-frontend-developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Iqra Maqsood</p><span>Frontend Developer</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="200">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\husnain-team-technicmentors.jpg" className="img-fluid team-member" alt="husnain-abbas-backend-developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Husnain Abbas</p><span>Backend Developer</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="300">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\mishal-team-technicmentors.jpg" className="img-fluid team-member" alt="mishal-digital-marketing-specialist" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Mishal</p><span>Digital Marketing Specialist</span></div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="400">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\taimoor-team-technicmentors.jpg" className="img-fluid team-member" alt="taimoor-sheikh full stack developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Muhammad Taimoor</p><span>Full Stack Developer</span></div>
    </div>
  </div>
</div>

{/* ROW 8 */}
{/* <div className="row">
  <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-delay="100">
    <div className="member">
      <div className="member-img">
        <img src="assets\img\Teams\mohsin-team-technicmentors.jpg" className="img-fluid team-member" alt="mohsin-ali-jr-laravel-developer" />
        <div className="social">
          <a href="#/"><i className="bi bi-twitter"></i></a>
          <a href="#/"><i className="bi bi-facebook"></i></a>
          <a href="#/"><i className="bi bi-instagram"></i></a>
          <a href="#/"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>
      <div className="member-info"><p>Mohsin Ali</p><span>Jr. Laravel Developer</span></div>
    </div>
  </div>
</div> */}
        </div>
      </section>

    </div>
  );
}
